export interface AboutNCXTextSectionProps {
  headline: string
  subheading: string
  body: string
  imageSrc: string
}

const AboutNCXTextSection = ({
  headline,
  subheading,
  body,
  imageSrc,
}: AboutNCXTextSectionProps) => (
  <div
    className="flex flex-col xl:flex-row"
    data-testid="about-ncx-text-section"
  >
    <img
      className="block object-cover shrink-0 xl:w-[548px] max-w-full"
      src={imageSrc}
      data-testid="about-ncx-text-section-img"
    />

    <div className="flex flex-col gap-[30px] px-9 md:px-14 py-7 md:py-9 bg-sand">
      <h3
        className="text-xl font-display font-medium leading-[140%] tracking-[0.4px]"
        data-testid="about-ncx-text-section-headline"
      >
        {headline}
      </h3>

      <h2
        className="text-2xl font-display font-semibold leading-[124%] tracking-[0.48px]"
        data-testid="about-ncx-text-section-subheading"
      >
        {subheading}
      </h2>

      <p
        className="text-lg font-body leading-[140%] tracking-[0.36px] pb-18 md:pb-0"
        data-testid="about-ncx-text-section-body"
      >
        {body}
      </p>
    </div>
  </div>
)

export default AboutNCXTextSection
